import register from '../../../../global/js/registry';
export default register('m-fhw-profile-jump-to-section', () => import(/* webpackMode: "lazy" */ './m-fhw-profile-jump-to-section.controller'));
